export default __webpack_public_path__ + "static/media/image-32.97983db2.png";